__turbopack_context__.v({
  "product-card": "styles-module-scss-module__t_i-tq__product-card",
  "product-placeholder-grid": "styles-module-scss-module__t_i-tq__product-placeholder-grid",
});
